import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  widgetInfo: {
    id: 'o4HhUI',
    defaultMessage:
      'IBM offers flexible pricing options for the individual user or the entire enterprise.',
  },
  getROIButton: {
    id: 'UJWi0S',
    defaultMessage: 'View IBM RPA benefits',
  },
  widgetStatement: {
    id: 'SVzxyP',
    defaultMessage:
      '  Enter the rough size of the solution you need to receive an approximate monthly price.',
  },
  widgetText_1: {
    id: 'd2YqrX',
    defaultMessage:
      'Find the right size for your solution and estimate your IBM Robotic Process Automation',
  },
  widgetText_3: {
    id: 'L3kuII',
    defaultMessage: 'price',
  },
  widgetText_4: {
    id: 'gwJiMs',
    defaultMessage: 'Pricing plans',
  },
  expandingCofiguration: {
    id: 'B7kyok',
    defaultMessage: 'Are you expanding a current configuration:',
  },
  expandingConfigurationHeadTooltip: {
    id: 'DFecgp',
    defaultMessage: 'Expanding a Configuration',
  },
  expandingConfigurationDescTooltip: {
    id: 'hEp8Jk',
    defaultMessage:
      'Select No for a new IBM RPA deployment or Yes if you want to expand an existing IBM RPA deployment.',
  },
  productToAcquire: {
    id: 'qi/cbl',
    defaultMessage: 'Desired configuration',
  },
  productToAcquireHeadTooltip: {
    id: 'qi/cbl',
    defaultMessage: 'Desired configuration',
  },
  productToAcquireDescTooltip: {
    id: '4RVnny',
    defaultMessage:
      'Please select the deployment option of the product as Software as a Service (SaaS) or as On-Premise. With SaaS the RPA Control Center is hosted by IBM in the cloud. Client software including Studio, Bot Agents and Launchers are deployed on your own infrastructure for both SaaS and on-premise.',
  },
  invalidVmText_1: {
    id: 'OL+Brn',
    defaultMessage: 'Maximum to process',
  },
  invalidVmText_2: {
    id: 'xIWCOZ',
    defaultMessage: '. Please contact us',
  },
  invalidVmText_3: {
    id: 'k7So66',
    defaultMessage: 'Minimum to process',
  },
  configurationSize: {
    id: 'fsMtKM',
    defaultMessage: 'Configuration size:',
  },
  configurationSizeHeadTooltip: {
    id: 'R08PI3',
    defaultMessage: 'Configuration size',
  },
  configurationSizeDescTooltip: {
    id: 'ewCPFK',
    defaultMessage:
      'Please select one of the suggested configuration sizes appropriated to your requirements. Small for is appropriate for small-medium sized businesses implementing their first RPA project. Medium is appropriate for mid-market organizations starting out on their automation journey. Large is appropriate for enterprises with an ambitious automation strategy.',
  },
  numberOfEnvironments: {
    id: 'z1mx2m',
    defaultMessage: 'Number of environments',
  },
  numberOfEnvironmentsHeadTooltip: {
    id: 'z1mx2m',
    defaultMessage: 'Number of environments',
  },
  numberOfEnvironmentsDescTooltip: {
    id: 'rRQG2y',
    defaultMessage:
      'Specify the number of environments you require to host your RPA solution. One environment can be used for development, test and production, but following IT best practices three environments will provides better isolation between development, test and production. Mature IT departments may require multiple test environments for different purposes, such as functional testing, performance testing, regression testing, etc.',
  },
  numberOfUnattendedRobots: {
    id: 'KUpP3V',
    defaultMessage: 'Number of unattended robots',
  },
  numberOfUnattendedRobotsHeadTooltip: {
    id: 'KUpP3V',
    defaultMessage: 'Number of unattended robots',
  },
  numberOfUnattendedRobotsDescTooltip: {
    id: 'm4SBdc',
    defaultMessage:
      'Unattended bots run on a server and perform entire automations without any human intervention, using system credentials to access software applications. They can either be scheduled to run at specific times, triggered via an API, or initiated via a chatbot session.',
  },
  numberOfAttendedRobots: {
    id: 'mERIqR',
    defaultMessage: 'Number of attended robots',
  },
  numberOfAttendedRobotsHeadTooltip: {
    id: 'mERIqR',
    defaultMessage: 'Number of attended robots',
  },
  numberOfAttendedRobotsDescTooltip: {
    id: 'drkU5P',
    defaultMessage:
      'Attended bots are designed to assist users perform automations on their desktop computers, using the users credentials to access software applications. They are triggered directly by the user and can exchange information with the user during the automation.',
  },
  labelTotalOnPremVms: {
    id: 'cYA0Jo',
    defaultMessage: 'Total number of On-Premise VMs Needed:',
  },
  totalOnPremiseHeadTooltip: {
    id: 'TDAG+S',
    defaultMessage: 'Title description.',
  },
  totalOnPremiseDescTooltip: {
    id: 'l/Y0ZU',
    defaultMessage: 'Text Description here',
  },
  thankYouTitle: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  thankYouSubTitle: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  thankYouDetailsTitle: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  totalOnPremVvmsTitle: {
    id: 'OCFQmx',
    defaultMessage: 'Number On-prem VMs',
  },
  totalCloudInstancesTitle: {
    id: '/7KuLx',
    defaultMessage: 'Number of Cloud Instances',
  },
  interestedInContainersTilte: {
    id: 'aDa1hc',
    defaultMessage: 'Interested in pricing containers',
  },
  returnToEstimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  inlineTextTitleSaaS: {
    id: 'j3GVIG',
    defaultMessage: 'Software as a service information',
  },
  inlineTextSaaS: {
    id: '+F+1Qd',
    defaultMessage:
      'Hosted RPA server in the cloud can reduce infrastructure and maintenance costs. Pricing does not include the cost of infrastructure to deploy the client software.',
  },
  inlineTextTitleLicense: {
    id: 'Ylrxw5',
    defaultMessage: 'Software On-Premises subscription Information',
  },
  inlineTextLicense: {
    id: 'wCTRGK',
    defaultMessage:
      'Pricing does not include the cost of infrastructure to host the RPA server and client software.',
  },
  footnoteOne: {
    id: 'QQ12iG',
    defaultMessage:
      'Estimated price is not a formal offer from IBM or an IBM Business Partner. Certain factors such as RPA configuration, add-ons, and discounts may affect final price. IBM Business Partners set and provide their own RPA pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate. Your quoted price may vary. Prices in other currencies and/or countries will vary and may be higher. Minimum term is 12 months.',
  },
  CloseText: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  contactInfo: {
    id: '5axkLt',
    defaultMessage: 'For a solution this size please get in touch with us.',
  },
  contactUs: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  estimatedCosts: {
    id: 'lSIpRl',
    defaultMessage: 'Estimated monthly price',
  },
  asteriskPrice: {
    id: 'k6nzq4',
    defaultMessage: ' Prices shown do not include tax.',
  },
  getQuoteButton: {
    id: 'aAghQx',
    defaultMessage: 'Request a quote now',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  availableIn: {
    id: 'lFk6mk',
    defaultMessage: 'The RPA estimator is available in',
  },
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  requiremnet: {
    id: 'FCjGve',
    defaultMessage: 'Requirement',
  },
  selection: {
    id: 'xLigG0',
    defaultMessage: 'Selection',
  },
});

export default messages;
